import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';

interface Response extends BackendResponse {
  message: string;
}

export function useSendMobileOtp() {
  return useMutation({
    mutationFn: (mobileNumber: string) => sendMobileOtp(mobileNumber),
  });
}

function sendMobileOtp(mobileNumber: string): Promise<Response> {
  return apiClient
    .post('mobile-otp/send', {mobile_number: mobileNumber})
    .then(response => response.data);
}
